export default __webpack_public_path__ + "static/media/Filter.cc90f34c.svg";